import { useCallback, useRef } from 'react';
import { Keyboard } from 'react-native';

import { EventArg } from '@react-navigation/native';
import { NavigationProp } from '@react-navigation/native';

import { GASbkEvents } from '@/feature/analytics/sbk/ga-sbk-events';

import { BetSlipParamsList } from '../types';

/**
 * Hook to track the toggle event of the bet slip between singles and combo
 */
export const useTrackToggleBetSlip = () => {
    const isUserAction = useRef(false);

    const screenListeners = useCallback(
        ({ navigation }: { navigation: NavigationProp<BetSlipParamsList> }) => ({
            focus: (data: EventArg<'focus'>) => {
                if (isUserAction.current) {
                    const isSinglesTab = data.target?.includes('Singles');
                    if (isSinglesTab !== undefined) {
                        GASbkEvents.toggleBetTypeTab(isSinglesTab ? 'singles' : 'combo');
                    }
                    isUserAction.current = false;
                }
            },
            swipeStart: () => {
                isUserAction.current = true;
                Keyboard.dismiss();
            },
            tabPress: (e: EventArg<'tabPress', true>) => {
                isUserAction.current = true;

                // There's a bug when you navigate tabs with the keyboard visible, it will close the keyboard but leave a blank space
                // This workaround waits for the keyboard to hide before navigating to the new tab

                if (!Keyboard.isVisible()) {
                    return;
                }

                e.preventDefault();

                const route = navigation.getState().routes.find(r => r.key === e.target);

                const subscription = Keyboard.addListener('keyboardDidHide', () => {
                    subscription.remove();
                    if (route) {
                        navigation.navigate(route.name);
                    }
                });
                Keyboard.dismiss();
            },
        }),
        []
    );
    return { screenListeners };
};
